/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import styled from 'styled-components';
import { PlusOutlined } from '@ant-design/icons';
import Button from 'components/forms/Button';
import InputWithSelectRow from './InputWithSelectRow';

const Title = styled.h2`
    font-family: ${({ theme }) => theme.font.title};
    font-size: 1.9em;
    color: ${({ theme }) => theme.colour.dark};
    text-align: left;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
`;

const Inclusions = ({
    onInputChange,
    onSelectChange,
    onToggleChange,
    onInputNameChange,
    formData,
    currency,
    removeItem,
    onAddRow,
    selectStyles,
}) => (
    <div className="pkgCalc-form-inclusions">
        <Title>Inclusions</Title>
        <hr style={{ marginBottom: '2em' }} />
        {formData.inclusions.map((row) => (
            <InputWithSelectRow
                id={row.id}
                editableTitle={!row.isPreset}
                title={row.name}
                removeItem={removeItem}
                onInputChange={onInputChange}
                onSelectChange={onSelectChange}
                onToggleChange={onToggleChange}
                onChangeTitle={onInputNameChange}
                value={row.value}
                amount={row.amount}
                currency={currency}
                applied={row.applied}
                pricePerSelected={row.pricePer}
                key={row.id}
                selectStyles={selectStyles}
            />
        ))}
        <Button style={{ marginTop: '2%', marginBottom: '2%' }} icon={<PlusOutlined />} onClick={onAddRow}>
            Add
        </Button>
    </div>
);

export default Inclusions;
